import { actionTypes } from "../../actions/action_types";

const initialState = {
  summary_overall: null,
  summary_cluster: null,
  summary_area: null,
};

export default function daily_summary_reducer(state = initialState, action) {
  var stateCopy = Object.assign({}, state);

  switch (action.type) {
    case actionTypes.REPORTS_DAILY_SUMMARY_GET_OVERALL:
      stateCopy.summary_overall = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_DAILY_SUMMARY_GET_CLUSTER:
      stateCopy.summary_cluster = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_DAILY_SUMMARY_GET_AREA:
      stateCopy.summary_area = action.payload;
      return stateCopy;

    default:
      return state;
  }
}
